import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxTextCompositeComponent } from './rx-text-composite.component';
import { RxTipModule } from '@nrwl/rx-tip';
import { RxUiModule } from '@nrwl/rx-ui';
import { RxCheckboxModule } from '@nrwl/rx-checkbox';

@NgModule({
  imports: [CommonModule, RxTipModule, RxCheckboxModule, RxUiModule, RxTextCompositeComponent],
  exports: [RxTextCompositeComponent],
})
export class RxTextCompositeModule {}
